import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useDashboardTheme } from '../../contexts/DashboardThemeContext';

/**
 * Light / dark theme switch for admin & vendor dashboards.
 */
const ThemeToggle = ({ className = '', showLabel = false, size = 'md' }) => {
  const { theme, toggleTheme, isDark } = useDashboardTheme();

  const iconClass = size === 'sm' ? 'w-4 h-4' : 'w-5 h-5';
  const padClass = size === 'sm' ? 'p-1.5' : 'p-2';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className={`
        ${padClass} rounded-lg transition-colors
        text-gray-500 hover:text-gray-900 hover:bg-gray-100
        dark:text-gray-400 dark:hover:text-gray-100 dark:hover:bg-gray-800
        ${className}
      `}
      title={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
    >
      <span className="flex items-center gap-2">
        {isDark ? (
          <Sun className={iconClass} aria-hidden />
        ) : (
          <Moon className={iconClass} aria-hidden />
        )}
        {showLabel && (
          <span className="text-sm font-medium hidden sm:inline">
            {theme === 'dark' ? 'Light' : 'Dark'}
          </span>
        )}
      </span>
    </button>
  );
};

export default ThemeToggle;
